var map = {
	"./blog.yml": 57,
	"./cloud.yml": 58,
	"./color.yml": 59,
	"./country.yml": 60,
	"./dio.yml": 61,
	"./doc.yml": 62,
	"./emoji.yml": 63,
	"./git.yml": 64,
	"./icon.yml": 65,
	"./license.yml": 66,
	"./link.yml": 67,
	"./metrics.yml": 68,
	"./people.yml": 69,
	"./soft.yml": 70,
	"./src.yml": 71,
	"./status.yml": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;